module.exports = __webpack_public_path__ + "static/media/design-guide-photo-2.83e38314.PNG";